import { h } from '@debbie/cortex/dist/index.js';
import { useUpdateTypesMap } from '@debbie/cortex/dist/update-types/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
const UpdateTypePreview = (props) => {
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const lang = useSelector((s) => s.lang);
    const updateType = updateTypesMap[props.id];
    return (React.createElement("div", null, updateType && (React.createElement(React.Fragment, null,
        React.createElement("p", null,
            React.createElement(Link, { to: `/settings/workflows/tasks/${props.id}` }, lang.updateTypes[props.id] || updateType.label))))));
};
export default UpdateTypePreview;
//# sourceMappingURL=UpdateTypePreview.js.map